<template>
  <div id="app" :class="{ 'disable-scroll': modal }">
    <div v-cloak>
      <v-app :dark="goDark">
        <v-layout column py-2 :px-4="$vuetify.breakpoint.mdAndUp" :style="$vuetify.breakpoint.smAndDown ? 'padding: 16px 10px' : ''">
          <Header v-if="$route.name !== 'passwordReset'" />
          <template v-if="companyActive !== false">
            <router-view></router-view>
          </template>
          <v-alert
            color="error"
            class="err"
            icon="warning"
            value="true"
            v-else>{{$lang.global.notAvailable}}
          </v-alert>
        </v-layout>
        <Footer v-if="$route.name !== 'passwordReset'" />
      </v-app>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Header from '@/components/webshop/Header';
import Footer from '@/components/webshop/Footer';
import moment from 'moment';

export default {
  components: {
    Header,
    Footer,
  },
  computed: mapGetters({
    modal: 'modal',
    companyActive: 'companyActive',
    goDark: 'goDark',
  }),
  name: 'app',
  created() {
    const isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    this.$store.dispatch('goDark', isDark);
    localStorage.theme = isDark ? 'dark' : 'light';
    this.checkStaticHash();
    // if (this.$route.query &&
    //     (this.$route.query.first ||
    //         this.$route.query.last ||
    //         this.$route.query.email ||
    //         this.$route.query.phone)) {
    //   const data = {
    //     first: this.$route.query.first || '',
    //     last: this.$route.query.last || '',
    //     email: this.$route.query.email || '',
    //     phone: this.$route.query.phone || '',
    //   };
    //   localStorage.customerData = JSON.stringify(data);
    //   this.$router.push({ path: this.$route.path });
    // }

    // this.$webHelper.post('token/create', {
    //   foreignKey: 'Yl7Z7ukF9JwSmWQRocRFnFLhGsUMgwoF',
    //   webShopResourceId: 'iP8uTMOY',
    //   expirationDateTime: '2021-05-04T14:43:27.389+0000',
    //   payloadPublic: {
    //     backlink: 'http://localhost:20011/t/BUSINESS-2',
    //     ordercompletedlink: 'http://localhost:20011/api/preorder/callback?foreignKey=%23foreignKey%23&orderId=%23orderId%23',
    //     email: 'alina@netkey.at',
    //     first: 'Alina',
    //     last: 'Kessler',
    //     phone: '+436602614891',
    //   },
    //   payloadPrivate: {
    //     orderCompletedCallback: 'http://localhost:20011/api/preorder/callback?foreignKey=#foreignKey#&orderId=#orderId#',
    //   },
    //   modifiedOn: '2021-04-13T14:43:28.426+0000',
    //   createdOn: '2021-04-13T14:43:28.426+0000',
    // })
    //   .then((res) => {
    //     console.log(res);
    //   });


    if (this.$route.query && this.$route.query.token) {
      const token = this.$route.query.token;
      this.$webHelper.get(`token/${token}`, null, this.$router)
        .then((res) => {
          if (!res.success) return;
          localStorage.tokenId = JSON.stringify({ tokenId: token || '', deleteTime: moment().add('30', 'minutes') });
          const tokenData = Object.assign({}, res.body.company, res.body.token.payloadPublic);
          if (tokenData &&
                (tokenData.first ||
                    tokenData.last ||
                    tokenData.email ||
                    tokenData.phone ||
                    tokenData.backlink ||
                    tokenData.ordercompletedlink ||
                    tokenData.tokenId)) {
            const data = {
              first: tokenData.first || '',
              last: tokenData.last || '',
              email: tokenData.email || '',
              phone: tokenData.phone || '',
            };
            if (tokenData.backlink) {
              localStorage.backlink = JSON.stringify({ backlink: tokenData.backlink || '', deleteTime: moment().add('30', 'minutes') });
            } else {
              localStorage.removeItem('backlink');
            }
            if (tokenData.ordercompletedlink) {
              localStorage.ordercompletedlink = JSON.stringify({ backlink: tokenData.ordercompletedlink || '', deleteTime: moment().add('30', 'minutes') });
            } else {
              localStorage.removeItem('ordercompletedlink');
            }
            localStorage.customerData = JSON.stringify(data);
            this.$router.push({ path: this.$route.path });
          } else {
            localStorage.removeItem('customerData');
            localStorage.removeItem('backlink');
            localStorage.removeItem('ordercompletedlink');
            this.$router.push({ path: this.$route.path });
          }
        });
    }
    if (this.$route.name === 'resourceSet' || this.$route.name === 'resourceSet2') return;
    const company = this.$storage.company;
    let resourceId = this.$route.params.resourceId ? this.$route.params.resourceId : localStorage.getItem('webShopResourceId');
    if (resourceId === 'undefined' || resourceId === 'null') resourceId = null;
    if (resourceId || this.$route.name === 'menu') {
      if (this.$route.name === 'menu') {
        resourceId = this.$route.query.webShopResourceId;
        localStorage.webShopResourceId = this.$route.query.webShopResourceId;
      }
      this.$webHelper.get(`webshopresource/fetchbyexternalid/${resourceId}`, null, this.$router)
        .then((res) => {
          if (!res.success) return;
          localStorage.setItem('webShopResourceId', resourceId);
          const companyData = Object.assign({}, res.body.company, res.body.webShopResource);
          this.$storage.company = companyData;
          this.$store.dispatch('setCompany', companyData);
          this.$store.dispatch('setTimeZone', companyData.address.country === 'UK' ? 'Europe/London' : 'Europe/Vienna');
          this.$store.dispatch('setWorkingHours', companyData.openingDaysAndHours);
          document.title = `${companyData.name} ${this.$lang.global.webshop}`;
        });
    } else if (company) {
      this.$store.dispatch('setCompany', company);
      this.$store.dispatch('setTimeZone', company.address.country === 'UK' ? 'Europe/London' : 'Europe/Vienna');
      this.$store.dispatch('setWorkingHours', company.openingDaysAndHours);
      document.title = `${company.name} ${this.$lang.global.webshop}`;
    }
    if (!resourceId && this.$route.name !== 'menu') {
      const url = window.location.origin;
      this.$webHelper.get(`webshopresource/fetchbyurl?url=${url}`, null, this.$router)
        .then((res) => {
          if (!res.success) return;
          localStorage.setItem('webShopResourceId', res.body.webShopResource.webShopResourceExternalId);
          this.$storage.company = Object.assign({}, res.body.company, res.body.webShopResource);
          window.location.reload(true);
        });
    }
  },
  mounted() {
    this.$router.beforeEach((to, from, next) => {
      this.checkStaticHash();
      next();
    });
    window.matchMedia('(prefers-color-scheme: dark)')
      .addEventListener('change', this.colorThemeListener);
  },
  methods: {
    colorThemeListener(event) {
      if (event.matches) {
        localStorage.theme = 'dark';
        this.$store.dispatch('goDark', true);
      } else {
        localStorage.theme = 'light';
        this.$store.dispatch('goDark', false);
      }
    },
    checkStaticHash() {
      this.$webHelper.get('/static/version.txt')
        .then((staticHash) => {
          if (staticHash) {
            if (!localStorage.staticHash || localStorage.staticHash !== staticHash.body) {
              localStorage.staticHash = staticHash.body;
              window.location.reload(true);
            }
          }
        });
    },
  },
  beforeDestroy() {
    window.removeEventListener('change', this.colorThemeListener);
  },
};
</script>
<style lang="scss">
  [v-cloak] {
    display: none;
  }
  html {
    overflow-y: auto !important;
  }
  #app {
    /*DIALOG FIX Width*/
    width: 100vw;
    /**/
    /*background-color: #F5F5F5 !important;*/
    overflow-y: auto;
    overflow-x: hidden;
    font-family: 'Lato', sans-serif;
  }
  /*.theme--light.application {*/
  /*  background-color: #00a86b !important;*/
  /*}*/
  .v-dialog { overflow-y: visible !important; }
  .v-input {
    margin-top: 0 !important;
  }
  .v-table thead tr:first-child {
    border-bottom: 1px solid rgba(0,0,0,.12);
  }
  .v-table tbody tr:not(:last-child) {
    border-bottom: 1px solid rgba(0,0,0,0.12);
  }
  @media only screen and (max-width: 768px) {
    .disable-scroll {
      height: 100vh;
      overflow: hidden !important;
    }
  }
  .slide-fade-enter-active {
  transition: all .5s ease;
  }
  .slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateY(-10px);
    opacity: 0;
  }

  .radio-wrap {
    position: relative;
    flex: 0.5 1 auto !important;
    max-width: 100%;

    .radio-group--column .input-group__input {
      display: inline-flex !important;
    }

    .single-radio {
      padding-left: 32px !important;
    }

    .input-group.input-group--selection-controls label {
      width: auto;
      position: relative;
      overflow: visible;
      max-width: 100%;
      left: 0;
      display:inline-block;
      word-wrap: break-word;
    }

    .input-group.input-group--selection-controls .input-group__input {
      width: auto;
      position: absolute;
      left: 0;
      top: 0;
      margin: 0
    }
  }
  .v-alert {
    box-shadow: 0 3px 3px -2px rgba(0,0,0,.2),0 3px 4px 0 rgba(0,0,0,.14),0 1px 8px 0 rgba(0,0,0,.12);
    margin-bottom: 16px !important;
    i {
      color: #fff !important;
    }
  }
  #app > div.application--wrap > div > div > div > div.flex.section.categories.xs12.md7.lg8.pa-0 > div > div.flex.px-0.xs12 > div > div > div.v-input__slot {
    border-radius: 100px !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue